import * as z from 'zod';

export type ServicePlanCategoryFormSchemaValues = z.infer<typeof servicePlanCategoryFormSchema>;
export const servicePlanCategoryFormSchema = z
    .object({
        name: z.string().nonempty(),
        code: z.string().nonempty(),
    });